import {
    getOrganizationAccount,
    listOrganizationAccounts
} from './queries';
import {
    createOrganizationAccount,
    deactivateOrganizationAccount,
    updateOrganizationAccount,
} from './mutations';

import {GraphQLQuery,} from '@aws-amplify/api';

import {
    OrganizationAccount,
    CreateOrganizationAccount,
    DeactivateOrganizationAccount,
    GetOrganizationAccount,
    ListOrganizationAccounts,
    UpdateOrganizationAccount
} from "../types.ts";
import {generateClient} from "aws-amplify/api";


const client = generateClient();


// FNP-562: returns the page ENVELOPE, not a bare array. The infinite query needs
// `nextToken` to decide whether another page exists; unwrapping to `items` here
// would throw that away and make token pagination impossible above this line.
export const fetchRecords = async (query: {
    filter?: object;
    limit?: number;
    nextToken?: string | null;
}) => {
    const {
        filter,
        limit,
        nextToken
    } = query;
    const response = await client.graphql<GraphQLQuery<ListOrganizationAccounts>>({
                                                                                      query: listOrganizationAccounts,
                                                                                      variables: {
                                                                                          filter,
                                                                                          limit,
                                                                                          nextToken
                                                                                      },
                                                                                  });
    return {
        items: response.data?.listOrganizationAccounts.items ?? [],
        nextToken: response.data?.listOrganizationAccounts.nextToken,
    };
};

export const fetch = async (id: string) => {
    const response = await client.graphql<GraphQLQuery<GetOrganizationAccount>>({
                                                                                    query: getOrganizationAccount,
                                                                                    variables: {id: id},
                                                                                });
    return response.data?.getOrganizationAccount;
};

export const add = async (payload: object) => {
    const response = await client.graphql<GraphQLQuery<CreateOrganizationAccount>>({
                                                                                       query: createOrganizationAccount,
                                                                                       variables: {input: payload},
                                                                                   });
    return response.data?.createOrganizationAccount;
};

export const update = async (_id: string, record: OrganizationAccount) => {

    delete record.created;
    delete record.updated;

    const response = await client.graphql<GraphQLQuery<UpdateOrganizationAccount>>({
                                                                                       query: (updateOrganizationAccount),
                                                                                       variables: {input: record},
                                                                                   });
    return response.data?.updateOrganizationAccount;
};

export const deactivate = async (id: string) => {
    const response = await client.graphql<GraphQLQuery<DeactivateOrganizationAccount>>({
                                                                                           query: (deactivateOrganizationAccount),
                                                                                           variables: {input: {id: id}},

                                                                                       });
    return response.data?.deactivateOrganizationAccount;
};
